export class FloorPlanRequestDto {
    svgData?: string;
    jsonData?: string;
    roomId?: number;
}